export type NumericDraftMode = "decimal" | "integer";

export type NumericDraftParseResult = {
  empty: boolean;
  valid: boolean;
  parsed: number | null;
};

function invalidNumericDraft(empty: boolean): NumericDraftParseResult {
  return {
    empty,
    valid: false,
    parsed: null,
  };
}

export function normalizeNumericDraft(value: number | string | null | undefined): string {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? String(value) : "";
  }

  const trimmed = value.trim();
  if (trimmed === "") {
    return "";
  }

  return parseNumericDraft(trimmed, "decimal").valid ? trimmed : "";
}

export function parseNumericDraft(value: string, mode: NumericDraftMode): NumericDraftParseResult {
  const trimmed = value.trim();

  if (trimmed === "") {
    return invalidNumericDraft(true);
  }

  if (trimmed === "-" || trimmed === "." || trimmed === "-.") {
    return invalidNumericDraft(false);
  }

  if (mode === "integer" && !/^-?\d+$/.test(trimmed)) {
    return invalidNumericDraft(false);
  }

  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) {
    return invalidNumericDraft(false);
  }

  return {
    empty: false,
    valid: true,
    parsed,
  };
}
